// import { useEffect } from "react";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import { Theme, WithStyles, withStyles } from "@material-ui/core/styles";
import { CSSProperties } from "@material-ui/core/styles/withStyles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
const styles = (theme: Theme): Record<string, CSSProperties> => ({
  background: {
    backgroundColor: "lightgrey",
    minHeight: "100%",
    width: "100%",
    display:"flex"
  },
  bottomLogo: {
    paddingTop: "10px",
  },
  contents: {
    padding: "1rem",
  },
  header: {
    backgroundColor: "#F5F5F5",
  },
  image: {
    height: 50,
  },
  logoDiv: {
    height: 50,
    maxHeight: 50,
    minHeight: 50,
    textAlign: "center",
  },
  screen: {
    maxWidth: "800px",
    paddingBottom: 10,
    paddingTop: 10,
    width: "100%",
  },
  textCenter: {
    textAlign: "center",
    fontSize:"21px",
    margin:"15px 0px",
    fontWeight:"bold",
  },
  topLogo: {},
});

interface IMobilePageProps {
  children: React.ReactNode;
  headerIcon?: React.ReactNode;
  header: string;
  title: string;
  subtitle?: string;
  schoolLogo: string;
  schoolLogo2: string;
  tagline?: string;
  schoolName?: string;
  headLine?: string;
  type?: string;
  forVideoMidSeson?: boolean;
}

type IDirectorPagePropsWithStyles = IMobilePageProps &
  WithStyles<keyof ReturnType<typeof styles>>;
const MobilePage: React.SFC<IDirectorPagePropsWithStyles> = ({
  classes,
  children,
  title,
  header,
  headerIcon,
  schoolLogo,
  schoolLogo2,
  subtitle,
  headLine,
  type,
  forVideoMidSeson,
  // tagline,
  schoolName,
}: IDirectorPagePropsWithStyles) => {
  // useEffect(() => {
  //   const currentUrl = window.location.href;
  // const urlMappings: { [key: string]: string } = {
  //   "student": "https://gritback.makemagento.com/student",
  //   "coach": "https://gritback.makemagento.com/coach/",
  //   "parent": "https://gritback.makemagento.com/parent/",
  // };
  // Object.keys(urlMappings).forEach((key) => {
  //   if (currentUrl.includes(`/${key}/`)) {
  //     window.location.href = urlMappings[key];
  //   }
  // });
  // }, []);
  return (
    <div className="grid-coach-member">
      <Grid
         style={{minHeight:"100vh"}}
        className={classes.background}
        container={true}
        direction="column"
        alignItems="center"
      >
        <Grid className={classes.screen}>
          <div>
            <div className={`${classes.logoDiv} ${classes.topLogo}`}>
              {schoolLogo !== "" && (
                <img
                  id="target"
                  alt="Loading"
                  src={schoolLogo}
                  className={classes.image}
                />
              )}
            </div>
            <h2 className={classes.textCenter}>
              {schoolName !== "" ? schoolName : "."}
            </h2>
                    {/* <span>{tagline !== '' ? tagline: '.'}</span> */}
          </div>
          <Card>
            <CardHeader
              className={classes.header}
              title={
                <Typography variant="h4">
                  {headerIcon} {header}
                </Typography>
              }
            />
            <Grid className={classes.contents}>
              <Typography variant="h5">{title}</Typography>
              {headLine === "Expectations" && type === "Coach" && ( 
                 <Typography> The goal of this self-evaluation is to reflect on your leadership in each area and respond as if you were predicting your class’s feedback.
                 Consider how your leadership impacts your class and take your best guess at how they would answer each question about you.</Typography>)}
                 {headLine === "Other" && type === "Student" && forVideoMidSeson === false &&
                  <Typography>
                    Confidentiality is important to us. We promise to keep your specific remarks confidential between us. You can trust that your comments will not be shared with your {title.includes("School Admin") ? "School Admin" : "Teacher"}.
                  </Typography>
                 }
                 {headLine === "Other" && type === "Student" && forVideoMidSeson === true &&
                  <Typography>
                    This survey gives you a direct connection to your teacher, who will see your individual responses. They want your honest input to understand how you feel and how to better support you and the class. By sharing openly and honestly, we can work together to build something better, together.
                     </Typography>
                 }
                 {
                 ( headLine === "Expectations" && forVideoMidSeson === true  && type === "Student") && 
                 <Typography>This survey gives you a direct connection to your teacher, who will see your individual responses. They want your honest input to understand how you feel and how to better support you and the class. By sharing openly and honestly, we can work together to build something better, together.</Typography> }
              <Typography color="textSecondary" style={{ whiteSpace: "pre-wrap" }}>
                {/* {subtitle} */}
              </Typography>
              {children}
            </Grid>
          </Card>
          <div className={`${classes.logoDiv} ${classes.bottomLogo}`}>
            {schoolLogo2 !== "" && (
              <img
              style={{marginBottom:"15px"}}
                id="target"
                alt="Loading"
                src={schoolLogo2}
                className={classes.image}
              />
            )}
          </div>
          <div>
          <p className={classes.textCenter}
             style={{marginTop:"15px"}}>
              Copyright © {new Date().getFullYear()} all rights reserved, Grit
              Leadership<sup>TM</sup>, LLC
            </p>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default withStyles(styles)(MobilePage);




// WEBPACK FOOTER //
// ./src/components/MobilePage.tsx